import { IAwardsStyle } from '../models/index.js';
export const awardsStyle: IAwardsStyle = {
	children: {
		wrapper: {
			overrides: [
				{
					selector: '[data-selector="base-carousel-dots"]',
					style: {
						display: 'none',
					},
				},
				{
					selector: '[data-selector="overview-award-wrapper"]',
					style: {
						text: {
							align: 'left',
						},
					},
				},
			],
		},
		awardWrapper: {
			display: 'inline-flex',
			padding: {
				bottom: '10px',
			},
			margin: {
				right: '20px',
			},
		},
	},
};
